function fromUnixTimestamp (value) {
    return new Date(parseInt(value) * 1000)
}
function resetHours(c) {
    c.setHours(0)
    // after reset hours, shift to timezone minutes
    c.setTime(c.getTime() - c.getTimezoneOffset() * 60000)
}
function resetTime(c, groupBy) {
    switch (groupBy) {
    case "g2_days":
        resetHours(c)
        break
    case "g4_months":
        c.setDate(1)
        resetHours(c)
        break
    }
    c.setMinutes(0)
    c.setSeconds(0)
    c.setMilliseconds(0)
    return c
}

function toDate (value) {
    if (!value)
        return ""
    let options = {year: 'numeric', month: 'numeric', day: 'numeric'}
    return new Intl.DateTimeFormat("en", options).format(fromUnixTimestamp(value))
}

function toDateTime (value) {
    if (!value)
        return ""
    let options = {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'}
    // Handle both Unix timestamps (number or numeric string) and ISO strings
    let date
    if (typeof value === 'number' || /^\d+$/.test(value)) {
        date = fromUnixTimestamp(value)
    } else {
        date = new Date(value)
    }
    return new Intl.DateTimeFormat("en", options).format(date)
}

function toHour (value) {
    if (!value)
        return ""
    let options = {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
    return new Intl.DateTimeFormat("en", options).format(fromUnixTimestamp(value))
}


class Filler {
    constructor(groupBy, fields, days) {
        this.nextDate = {
            g1_hours: c => c.setHours(c.getHours() + 1),
            g2_days: c => c.setDate(c.getDate() + 1),
            g4_months: c => c.setMonth(c.getMonth() + 1),
        }[groupBy]
        this.dummy = {}
        fields.forEach(key => {
            this.dummy[key] = 0
        });
        let dt = resetTime(new Date(), groupBy)
        // this.tombstone = {
        //     "datetime": dt.getTime() / 1000,
        //     "access_key": "",
        //     ...this.dummy
        // }
        // start value (from)
        if (days) {
            dt.setDate(dt.getDate() - days);
            this.curr = dt;
        }
    }
    run(item) {
        let items = [];
        let until = fromUnixTimestamp(item["datetime"]);
        if (!this.curr) {
            this.curr = until;
        }
        this.nextDate(this.curr);
        while(this.curr < until) {
            items.push({
                ...item,
                ...this.dummy,
                datetime: this.curr.getTime() / 1000
            });
            this.nextDate(this.curr);
        }
        return [...items, item];
    }
}

export { toDate, toDateTime, toHour, Filler };
